import formatDate from '../../../../components/common/formatDate';

interface IProps {
  moduleData: any;
}

type revisionObj = { rev_no: number; [key: string]: string | number };
const TFoot = ({ moduleData }: IProps) => {
  return (
    <tfoot>
      <tr>
        <th rowSpan={5} colSpan={1}>
          Legend For Control In charge
        </th>
        <th rowSpan={5} colSpan={2}>
          C-Critical <br /> S-Significant <br /> W - Operator <br /> I -
          Inspector <br /> E - Supervisor <br /> P-Process Approval <br />
          R-Patrol Inspection <br />
          AM- Automatic Measurement
        </th>
        <th></th>
        <th></th>
        <th colSpan={4}> </th>
        <th colSpan={2}> </th>
        <td colSpan={2}>{moduleData?.prepared_by} </td>
        <td colSpan={2}>{moduleData?.verify_by} </td>
        <td colSpan={2}>{moduleData?.approved_by} </td>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th colSpan={4}> </th>
        <th colSpan={2}> </th>
        <th colSpan={2}>PREPARED BY </th>
        <th colSpan={2}> VERIFY BY</th>
        <th colSpan={2}>APPROVED BY </th>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th colSpan={4}> </th>
        <th colSpan={2}> </th>
        <th colSpan={4} rowSpan={3}>
          {' '}
          COPY STATUS
        </th>
        <th align="left">ISSUE BY </th>
        <td style={{ textAlign: 'left' }}>{moduleData?.issue_by} </td>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th colSpan={4}> </th>
        <th colSpan={2}> </th>
        <th align="left">ISSUE DATE </th>
        <td style={{ textAlign: 'left' }}>
          {formatDate(moduleData?.issue_date)}{' '}
        </td>
      </tr>
      <tr>
        <th>REV. NO</th>
        <th>DATE</th>
        <th colSpan={4}>DESCRIPTION </th>
        <th colSpan={2}> REASON FOR CHANGE</th>
        <th align="left">ISSUE NO</th>
        <td style={{ textAlign: 'left' }}>{moduleData?.issue_no}</td>
      </tr>
      {/* revision map  */}
      {moduleData &&
        moduleData.revisionData
          // .sort((a: revisionObj, b: revisionObj) => b.rev_no - a.rev_no)
          .map((revsion: revisionObj, index: number) => (
            <tr>
              <td></td>
              <td colSpan={2}> </td>
              <td>{revsion?.rev_no}</td>
              <td>{formatDate(revsion?.rev_date)}</td>
              <td colSpan={4}>{revsion?.summary}</td>
              <td colSpan={2}>{revsion?.reason}</td>
              <td colSpan={6}></td>
            </tr>
          ))}
    </tfoot>
  );
};

export default TFoot;
